<template>
    <div id="Content" v-if="IsChecking === true">
        アカウントを検証しています。しばらくお待ちください。。。
    </div>
    <div v-if="IsVerified === true">
        <p>メールアドレス{{ Email }}で登録されたアカウントが検証されました。</p>
        <span style="font-weight: bold;">{{ SecondsLeft }}秒後</span>に転送されます。しばらくお待ちください。
    </div>
    <div v-if="VerificationFailed === true">
        <p>メールアドレス{{ Email }}で登録されたアカウントは検証できませんでした。</p>
        もう一度検証してください。問題が解決しない場合は、管理者に連絡してください。
    </div>
    <div v-if="AlreadyVerified === true">
        <p>そのアカウントはもう確認しました。ログインで続いてください。</p>
        <span style="font-weight: bold;">{{ SecondsLeft }}秒後</span>に転送されます。しばらくお待ちください。
    </div>
    <div v-if="IsOtherResponse">
        <p>{{ OtherResponse }}</p>
    </div>
</template>

<script>
import axios from 'axios';
export default{
    mounted(){
        const r = this.$router;
        const hash = new URLSearchParams(r.currentRoute.value.hash);
        const email = hash.get('#email');
        const code = hash.get('code');

        this.RequestVerification(email, code);
    },
    methods:{
        async RequestVerification(email, code)
        {
            this.Email = email;

            const param = {
                Email: email,
                Code: code
            };

            console.log('Request verification ', param);

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}verify`, param)
            .then(response => {
                return response;
            })
            .catch(error => {
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to verify account', error);
                return error.response;
            });

            this.IsChecking = false;

            const content = document.getElementById('Content');

            if (content === null)
            {
                return;
            }

            console.log('result',result);
            if (result !== null)
            {
                if (result.status === 204)
                {
                    this.AlreadyVerified = true;
                    this.Forward();
                }
                else if (result.status === 200)
                {
                    this.IsVerified = true;
                    this.Forward();
                }
                else
                {
                    this.IsOtherResponse = true;
                    this.OtherResponse = result.data.Result;
                }
            }
            else
            {
                this.VerificationFailed = true;
            }
        },
        Forward()
        {
            if (this.SecondsLeft > 1)
            {
                this.SecondsLeft--;
                setTimeout(()=>{
                    this.Forward();
                }, 1000);
            }
            else
            {
                this.$router.push('/');
            }
        }
    },
    data(){
        return{
            SecondsLeft: 4,
            Email: '',
            IsChecking: true,
            IsOtherResponse: false,
            OtherResponse: '',
            IsVerified: false,
            VerificationFailed: false,
            AlreadyVerified: false,
        }
    }
}
</script>